// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d0xM","rootMobile":"styles_rootMobile__2LB6e"};